import {MenuButton, MenuItem, MenuList} from '@reach/menu-button';
import {lighten} from 'polished';
import styled, {css} from 'styled-components';

import {buttonReset, colors, font} from '@app/styles/theme';

import {Button} from '@shared/ui/Button';
import {Icon} from '@shared/ui/Icon';

export const List = styled(MenuList)`
    margin-top: 8px;
    padding: 0;
    overflow: hidden;
    background-color: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: 6px;

    &:focus {
        outline: none;
    }
`;

export const Item = styled(MenuItem)`
    padding: 14px 20px;
    color: ${colors.textPrimary};
    cursor: pointer;
    font-family: ${font.family.primary};
    font-size: 12px;

    &:hover {
        background-color: ${colors.background};
        color: ${colors.brandDark};
    }
`;

export const CustomMenuButton = styled(MenuButton)`
    ${buttonReset};
`;

export const CustomIcon = styled(Icon)`
    margin-left: 15px;
`;

const btnBg = lighten(0.2, colors.brandPrimary);

export const CustomButton = styled(Button)<{isExpanded: boolean}>`
    ${(p) =>
        p.isExpanded &&
        css`
            // background-color: ${btnBg};
            // border-color: ${btnBg};

            // &:hover {
            //     background-color: ${lighten(0.2, colors.brandPrimary)} !important;
            //     border-color: ${btnBg} !important;
            // }
        `}
`;
export const CustomButtonDiv = styled.div<{isExpanded: boolean}>``;
